import Stores from './stores'

export default Stores
